import { useNav } from '../stores/navigation';
import { useUnlocked } from '../stores/unlocked';

export function HomeScreen() {
  const go = useNav((s) => s.go);
  const count = useUnlocked((s) => s.entries.length);

  return (
    <div className="screen">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 'clamp(28px, 10vw, 56px)',
        }}
      >
        <img
          src="/assets/images/title.png"
          alt="MarbleScramble"
          style={{
            width: 'min(360px, 80vw)',
            height: 'auto',
            objectFit: 'contain',
            filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.6))',
          }}
        />
        <p
          style={{
            fontFamily: "'Asimovian', system-ui, sans-serif",
            fontSize: 'clamp(11px, 3.2vw, 14px)',
            letterSpacing: '0.18em',
            color: 'var(--fg-muted)',
            marginTop: 'clamp(6px, 2vw, 12px)',
            marginBottom: 0,
          }}
        >
          AR EDITION
        </p>
      </div>

      <p className="muted" style={{ textAlign: 'center', marginTop: 'clamp(20px, 6vw, 32px)' }}>
        QR をスキャンしてキャラを呼び出す
      </p>

      <div className="stack" style={{ marginTop: 'auto', marginBottom: 'clamp(12px, 4vw, 20px)' }}>
        <button className="btn btn-block" onClick={() => go({ kind: 'scanner' })}>
          QR をスキャン
        </button>
        <button className="btn btn-secondary btn-block" onClick={() => go({ kind: 'collection' })}>
          コレクション ({count})
        </button>
        <a
          className="btn btn-secondary btn-block"
          href="https://www.brainstorm-inc.jp/marblescramble.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          ゲームポータル
        </a>
      </div>

      <p
        className="muted"
        style={{
          textAlign: 'center',
          fontSize: 'clamp(10px, 2.6vw, 12px)',
          lineHeight: 1.55,
          padding: '0 8px',
          marginBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
        }}
      >
        カメラ映像と QR 読取結果はこの端末内でのみ処理され、サーバーには送信されません。
        アンロック済みキャラと撮影写真は端末のローカルストレージ／フォトライブラリに保存されます。
      </p>
    </div>
  );
}
